import React from 'react';
import OtherDoc from './OtherDoc';
import moment from 'moment';
import http from 'utils/http';
import { dateToUTC, getLocatDate } from 'utils/converter';
import dayjs from 'dayjs';
import { toast } from 'react-toastify';

class OtherDocContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null,
      modal: false,
      screeningModal: false,
      search: {
        from: getLocatDate('YYYY-MM-DD'),
        to: getLocatDate('YYYY-MM-DD'),
      },
      data: [],
      filterData: [],
      docs: [],
      airline: [],
      flight: [],
      preScreen: [],
      filter: {
        airline: null,
        flight: null,
        flight_search: null,
      },
    };
  }

  componentDidMount() {
    this.fetchFlight();
  }


  handlePopover = (modal, doc) => {
    this.setState({
      modal,
      docs: [doc]
    });

  };

  fetchFlight = (search) => {
    let query = '';
    if (search) {
      query = `search=${this.state.search.search}`;
    } else {
      if (dayjs(this.state.search.from).isAfter(dayjs(this.state.search.to))) {
        toast.error('From date cannot be greater than To date');
        return;
      }
      const from = dayjs(this.state.search.from).format('YYYY-MM-DD');
      const to = dayjs(this.state.search.to).format('YYYY-MM-DD');
      query = `from=${dateToUTC(from + ' 00:00:00', 'YYYY-MM-DD HH:mm:ss')}&to=${dateToUTC(to + ' 23:59:59', 'YYYY-MM-DD HH:mm:ss')}`;
    }
    http.get('/archive/other?' + query).then(({ data }) => {
      if (data.status == 'success') {
        this.setState({ data: data.data }, () => {
          this.filterData();
          // this.handlePopover(false);
        });
      }
    });
  };

  handleFilterChange = (event, type) => {
    let value = event.target ? event.target.value : event;
    // const name = event.target ? event.target.name : event;

    this.setState((prevState) => ({
      search: {
        ...prevState.search,
        [type]: value
      }
    }));
  };

  getFilter = () => {
    let airline = [];
    let flight = [];
    this.state.data.map(a => {
      let f = a.flight_no + '/' + moment(a.flight_date).format('DDMMMYY').toUpperCase();
      if (!flight.includes(f)) {
        flight.push(f);
      }
      if (a.airline) {
        if (!airline.includes(a.airline.code)) {
          airline.push(a.airline.code);
        }
      }
    });
    this.setState({
      airline,
      flight
    });
  };

  filterData = (search = false) => {
    let data = [...this.state.data];
    if (search && this.state.filter.awb && this.state.filter.awb != '') {
      data = data.filter((a) => a.name === this.state.filter.awb);
    }
    this.setState({ filterData: data });
  };

  onChangefilter = (e) => {
    this.setState({
      filter: {
        ...this.state.filter,
        [e.target.name]: e.target.value
      }
    }, () => { e.target.name != 'awb' || (e.target.name == 'awb' && !e.target.value) ? this.filterData(e.target.name == 'awb' || e.target.name == 'awb_search') : {}; });
  };

  handlePopoverClose = () => {
    this.setState({
      attachment: false,
      anchorEl: false
    });

  };

  render() {
    return (
      <>
        <OtherDoc
          handlePopover={this.handlePopover}
          handlePopoverClose={this.handlePopoverClose}
          anchorEl={this.state.anchorEl}
          modal={this.state.modal}
          data={this.state.filterData}
          searchOptions={this.state.search}
          handleChange={this.handleFilterChange}
          search={this.fetchFlight}
          airline={this.state.airline}
          flight={this.state.flight}
          preScreen={this.state.preScreen}
          onChangefilter={this.onChangefilter}
          filter={this.state.filter}
          type={'OTHER'}
          docs={this.state.docs}
        />
      </>
    );
  }
}

export default OtherDocContainer;
